module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/3918dc54d894c699e9eef21f674b1ecf.png";